import React, { useEffect, useState } from "react";
import "../../css/leadCard.css";
import { removeTagFromLead } from "../../utilities/tagFunctions";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { fetchLeadDataThunk } from "../../features/leadDataInfoSlice";

function LeadCardTags({ leadId }) {
  const agentId = useSelector((state) => state.agent.userData).agentId;
  const [leadsTags, setLeadsTags] = useState([]);
  const dispatch = useDispatch()

  // ====== leads tags =====
  const leadTagsList = useSelector((state) => state.leadAllDataInfo?.leadTagsList);

  const handleRemoveLead = async (tagId) => {
    const tagRemoved = await removeTagFromLead(tagId, agentId, leadId);
    if (tagRemoved) {
        await dispatch(fetchLeadDataThunk({ leadId }))
    }
  };
  useEffect(() => {
    if (leadTagsList && leadTagsList.length > 0) {
      const transformedTags = leadTagsList
        .split(",")
        .map((tag) => tag.split("*"))
        .map(([id, name]) => ({ id, name }));
      setLeadsTags(transformedTags);
    } else {
      setLeadsTags([]);
    }
  }, [leadTagsList]);

  return (
    leadsTags.length > 0 &&
    leadsTags.map((tag, index) => (
      <div className="tagWrapper" key={`taggedLead${index}`}>
        {tag.name}
        <span
          className="removeTag solidQuilityDestructiveButton"
          onClick={() => handleRemoveLead(tag.id)}
        >
          x
        </span>
      </div>
    ))
  );
}

export default LeadCardTags;
